import { Component, EventEmitter, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder } from '@angular/forms';
import { HttpService } from '../../../../../core';
import { UserService } from 'src/app/core/services/user.service';
import { ToastrService } from 'ngx-toastr';
import { Constants } from '../../../../../core/services/constants.service';
import { environment } from '../../../../../../environments/environment';

@Component({
    selector: 'app-add-document-dialog',
    templateUrl: './add-document-dialog.component.html',
    styleUrls: ['./add-document-dialog.component.scss']
})
export class AddDocumentDialogComponent implements OnInit {

    project: any;
    form: any;
    isSubmitted: any;
    onUpdate = new EventEmitter();

    constants = Constants;
    VERIFICATION_CODE_URL = environment.VERIFICATION_CODE_URL;

    selectedTermsAttachments = [];
    selectedProjectAttachments = [];
    selectedEoiAttachments = [];

    isLoadingForTermsAttachments: boolean;
    isLoadingForProjectAttachments: boolean;
    isLoadingForEoiAttachments: boolean;

    isTermsTooLarge: boolean;
    isDocumentTooLarge: boolean;
    isEoiDocumentTooLarge: boolean;

    noUpload: boolean = true;


    user: any;

    constructor(private fb: FormBuilder,
        private httpService: HttpService,
        private userService: UserService,
        private toastr: ToastrService,
        private dialogRef: MatDialogRef<any>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {

    }

    ngOnInit(): void {
        this.project = this.data.project;

        this.isLoadingForTermsAttachments = false;
        this.isLoadingForProjectAttachments = false;
        this.isLoadingForEoiAttachments = false;

        this.httpService.getProjectDetailByProjectId(this.project.id).toPromise().then((projectDetail: any) => {
            if (projectDetail.data.eoiFile) {
                this.noUpload = true
            } else {
                this.noUpload = false
            }
        });

        this.userService.currentUser.subscribe((r: any) => {
            console.log(r, 'this.userService.currentUser');
            this.user = r;
        });
    }

    isFileValid(file) {
        return file.size <= Constants.UPLOAD_TERMS_FILE_SIZE && file.name.length < 255;
    }

    onFileChangeForTerms(event) {
        this.isTermsTooLarge = false;
        console.log(event.target.files, event.target.files[0]);
        if (event.target.files && event.target.files[0]) {
            for (let i = 0; i < 1; i++) {
                if (this.isFileValid(event.target.files[i])) {
                    this.selectedTermsAttachments = [event.target.files[i]];
                } else {
                    this.isTermsTooLarge = true;
                }
                console.log(this.selectedTermsAttachments);
            }

        }
    }

    onFileChangeForProject(event) {
        this.isDocumentTooLarge = false;
        console.log(event.target.files, event.target.files[0]);
        if (event.target.files && event.target.files[0]) {
            // const filesAmount = event.target.files.length;
            for (let i = 0; i < 1; i++) {
                if (this.isFileValid(event.target.files[i])) {
                    this.selectedProjectAttachments = [event.target.files[i]];
                } else {
                    this.isDocumentTooLarge = true;
                }
                console.log(this.selectedProjectAttachments);
            }

        }
    }

    onFileChangeForEoi(event) {
        this.isEoiDocumentTooLarge = false;
        if (event.target.files && event.target.files[0]) {
            const filesAmount = event.target.files.length;
            for (let i = 0; i < 1; i++) {
                if (this.isFileValid(event.target.files[i])) {
                    this.selectedEoiAttachments = [event.target.files[i]];
                } else {
                    this.isEoiDocumentTooLarge = true
                }
            }

        }
    }

    // 上传项目条款文件
    uploadTermsFiles() {
        const fd = new FormData();
        const notes = [];
        this.selectedTermsAttachments.forEach((file, index) => {
            fd.append('files', file);
            notes.push({
                id: this.user.id,
                firstName: this.user.firstName,
                lastName: this.user.lastName,
                headerUrl: this.user.headerUrl
            });
        });

        fd.append('notes', JSON.stringify(notes));

        this.isLoadingForTermsAttachments = true;
        this.httpService.uploadTermsFiles(this.project.id, fd).subscribe((res: any) => {
            console.log(res);
            if (res.code === 1) {
                this.selectedTermsAttachments = [];

                this.onUpdate.emit({ termFiles: res.data })

                this.toastr.success('Upload successful');
                this.isLoadingForTermsAttachments = false;

            } else if (res.code === 0) {
                this.toastr.error('Upload failed');
                this.isLoadingForTermsAttachments = false;
            }
        });
    }

    // 上传项目描述文件
    uploadDocumentFiles() {
        const fd = new FormData();
        const notes = [];
        this.selectedProjectAttachments.forEach((file) => {
            fd.append('files', file);
            // 保存用户头像姓名
            notes.push({
                id: this.user.id,
                firstName: this.user.firstName,
                lastName: this.user.lastName,
                headerUrl: this.user.headerUrl
            })
        });

        fd.append('notes', JSON.stringify(notes));

        this.isLoadingForProjectAttachments = true;
        this.httpService.uploadDocumentFiles(this.project.id, fd).subscribe((res: any) => {
            if (res.code === 1) {
                this.selectedProjectAttachments = [];

                this.onUpdate.emit({ documentFiles: res.data })

                this.toastr.success('Upload successful');
                this.isLoadingForProjectAttachments = false;


            } else if (res.code === 0) {
                this.toastr.error('Upload failed');
                this.isLoadingForProjectAttachments = false;
            }
        });
    }

    // 上传EOI文件
    uploadEoiDocumentFiles() {
        const fd = new FormData();
        this.selectedEoiAttachments.forEach((file) => {
            fd.append('file', file);
        });
        // this.isLoadingForEoiAttachments = true;

        this.httpService.uploadEoiFile(this.project.id, fd).subscribe((res: any) => {
            if (res.code === 1) {
                this.selectedEoiAttachments = [];
                this.onUpdate.emit({ eoiFiles: res.data })
                this.toastr.success('Upload successful');
                this.isLoadingForEoiAttachments = false;
                this.dialogRef.close()
            } else if (res.code === 0) {
                this.toastr.error('Upload failed');
                this.isLoadingForEoiAttachments = false;
            }
        })

    }

    removeTermsAttachment() {
        this.selectedTermsAttachments = [];
    }

    removeProjectAttachments() {
        this.selectedProjectAttachments = [];
    }
    removeEoiAttachments() {
        this.selectedEoiAttachments = [];
    }

    save() {
        if (this.selectedTermsAttachments.length !== 0) {
            this.uploadTermsFiles();
        }
        if (this.selectedProjectAttachments.length !== 0) {
            this.uploadDocumentFiles();
        }
        if (this.selectedEoiAttachments.length !== 0) {
            this.uploadEoiDocumentFiles();
        }
        this.dialogRef.close('success');
    }
}
